const initialState = {
    totalSell: 0,
    shopShare: 0,
    title: '',
    fromDate: '', 
    toDate: '', 
    showSellBox: false, 
};

const accumulative = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_ACCUMULATIVE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default accumulative;
